import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiInputBase, MuiButton, MuiTextField, MuiToolTip } from '../../../../../ui/MaterialUIComponents'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DialogComponentUtil } from '..';
import * as StringReplacer from '../../../../../../i18n/StringReplacer';
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";
class FixedTeachersAndTAsComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}
	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				{/* teachers box */}
				<MuiGrid container style={{ marginBottom: "5%" }} >

					{/* headding */}
					<MuiGrid container>
						<MuiToolTip
							placement="top-start"
							title={StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAs.headingForTeachers,
								{
									Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
									Grades: DialogComponentUtil.getToolTipString(this.props),
								})
							} >
							<MuiTypography style={theme.typography.h6} gutterBottom>
								{StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAs.headingForTeachers,
									{
										Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
										Grades: DialogComponentUtil.getGradeForTemplate(this.props),
									})
								}
							</MuiTypography>
						</MuiToolTip>
					</MuiGrid>

					{/*main container for  Box */}
					<MuiGrid container xs={12} alignItems="left" >

						{/* 1st Box */}
						<MuiGrid item xs={6} container alignItems="center" >

							{/* label for fixed teacher */}
							<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
								<MuiTypography style={theme.tableHeaderTextStyle}>		{i18n.fixedTeachersAndTAs.fixedTeacher}
								</MuiTypography>
							</MuiGrid>

							{/* autocomplete  */}
							<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
								<Autocomplete
									id="combo-box-demo"
									multiple
									value={this.props.fixedTeachersAndTAsForSubject.teachers.fixed}
									options={this.props.numberOfTeachers}
									getOptionLabel={option => option.firstName !== undefined ? option.firstName + " " + option.lastName + "-" + option.teacherId : option.teacherId}
									style={{ width: 400 }}
									onChange={(event, value) => { this.props.handleChangeForTeacherSubject('fixed', event, value) }}
									renderInput={params => (
										<MuiTextField
											{...params}
											InputProps={{ ...params.InputProps, disableUnderline: true }}
											fullWidth
										/>)}
								/>
							</MuiGrid>
						</MuiGrid>

						{/* 2nd Box */}
						<MuiGrid item xs={6} container  >

							{/* label for preferred teacher */}
							<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
								<MuiTypography style={theme.tableHeaderTextStyle}>		{i18n.fixedTeachersAndTAs.preferredTeacher}
								</MuiTypography>
							</MuiGrid>

							{/* autocomplete  */}
							<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
								<Autocomplete

									id="combo-box-demo"
									multiple
									value={this.props.fixedTeachersAndTAsForSubject.teachers.preferred}
									options={this.props.numberOfTeachers}
									getOptionLabel={option => option.firstName !== undefined ? option.firstName + " " + option.lastName + "-" + option.teacherId : option.teacherId}
									style={{ width: 400 }}
									onChange={(event, value) => { this.props.handleChangeForTeacherSubject('preferred', event, value) }}
									renderInput={params => (
										<MuiTextField
											{...params}
											InputProps={{ ...params.InputProps, disableUnderline: true }}
											fullWidth
										/>)} />
							</MuiGrid>
						</MuiGrid>

					</MuiGrid>

				</MuiGrid>

				{/* TA box */}
				<MuiGrid container >

					{/* headding */}
					<MuiGrid container>
						<MuiToolTip
							placement="top-start"
							title={StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAs.headingForTAs,
								{
									Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
									Grades: DialogComponentUtil.getToolTipString(this.props),
								})
							} >
							<MuiTypography style={theme.typography.h6} gutterBottom>
								{StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAs.headingForTAs,
									{
										Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
										Grades: DialogComponentUtil.getGradeForTemplate(this.props),
									})
								}
							</MuiTypography>
						</MuiToolTip>
					</MuiGrid>

					{/*main container for  Box */}
					<MuiGrid container xs={12} alignItems="left" >

						{/* 1st Box */}
						<MuiGrid item xs={6} container alignItems="center" >

							{/* label for fixed TA */}
							<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
								<MuiTypography style={theme.tableHeaderTextStyle}>
									{i18n.fixedTeachersAndTAs.fixedTA}
								</MuiTypography>
							</MuiGrid>

							{/* autocomplete  */}
							<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
								<Autocomplete
									id="combo-box-demo"
									multiple
									value={this.props.fixedTeachersAndTAsForSubject.TAs.fixed}
									options={this.props.numberOfTAs}
									getOptionLabel={option => option.firstName !== undefined ? option.firstName + " " + option.lastName + "-" + option.teacherId : option.teacherId}
									onChange={(event, value) => { this.props.handleChangeForTAsSubject('fixed', event, value) }}
									style={{ width: 400 }}
									renderInput={params => (
										<MuiTextField
											{...params}
											InputProps={{ ...params.InputProps, disableUnderline: true }}
											fullWidth
										/>)} />
							</MuiGrid>
						</MuiGrid>

						{/* 2nd Box */}
						<MuiGrid item xs={6} container  >

							{/* label for preferred TA*/}
							<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
								<MuiTypography style={theme.tableHeaderTextStyle}>
									{i18n.fixedTeachersAndTAs.preferredTA}
								</MuiTypography>
							</MuiGrid>

							{/* autocomplete  */}
							<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
								<Autocomplete
									id="combo-box-demo"
									multiple

									value={this.props.fixedTeachersAndTAsForSubject.TAs.preferred}
									options={this.props.numberOfTAs}
									getOptionLabel={option => option.firstName !== undefined ? option.firstName + " " + option.lastName + "-" + option.teacherId : option.teacherId}
									onChange={(event, value) => { this.props.handleChangeForTAsSubject('preferred', event, value) }}
									style={{ width: 400 }}
									renderInput={params => (
										<MuiTextField
											{...params}
											InputProps={{ ...params.InputProps, disableUnderline: true }}
											fullWidth
										/>)} />
							</MuiGrid>
						</MuiGrid>

					</MuiGrid>

				</MuiGrid>

				{/* buttons  */}
				<MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={this.props.handleCloseForDialog}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>

					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => this.props.onClickOfSave()}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>

			</React.Fragment>
		)
	}
}
export default FixedTeachersAndTAsComponent

// "headingForTeachers": "Teacher rules for <Subject> for <Grades>, <Sections>",
//         "fixedTeacher": "Fixed Teacher(s)",
//         "preferredTeacher": "Preferred Teacher(s)",
//         "headingForTAs": "TA rules for <Subject> for <Grades>, <Sections>",
//         "fixedTA": "Fixed TA(s)",
//         "preferredTA": "Preferred TA(s)"